[{"id":"psm-1","title":"Professional Scrum Master (PSM-1)","issuer":"Scrum.org","year":"2025","link":"/pdf?id=psm1"}]